function formatDate(date) {
  if (!date) return null

  if (!(date instanceof Date)) {
    date = new Date(date)
  }

  var month = date.getMonth() + 1
  if (month < 10) {
    month = '0'.concat(month)
  }

  var day = date.getDate()
  if (day < 10) {
    day = '0'.concat(day)
  }

  return date.getFullYear() + '-' + month + '-' + day
}

export default formatDate
